import {
  Activity,
  AlertCircle,
  AlertTriangle,
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  Bell,
  Calendar,
  Check,
  CheckCircle,
  ChevronDown,
  ChevronLeft,
  ChevronRight,
  ChevronUp,
  Clock,
  Cpu,
  CreditCard,
  Database,
  Download,
  Edit,
  Eye,
  FileText,
  Filter,
  Home,
  Image,
  Inbox,
  Info,
  Keyboard,
  Maximize,
  Menu,
  Minus,
  Pause,
  Play,
  Plus,
  RefreshCw,
  Redo2,
  RotateCcw,
  RotateCw,
  Undo2,
  Search,
  Send,
  Server,
  Settings,
  Shield,
  Sparkles,
  User,
  Users,
  X,
  Zap,
  type LucideProps,
} from "lucide-react";

/** 모니터 + 바 차트 커스텀 아이콘 */
const MonitorChart = ({ size = 24, ...props }: Omit<LucideProps, "ref">) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={1.8}
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <rect x="2" y="3" width="20" height="14" rx="2" />
    <path d="M8 21h8M12 17v4" />
    <path d="M7 13v-2M12 13v-4M17 13v-6" />
  </svg>
);

/** 아이콘 이름 → lucide-react 컴포넌트 매핑 */
const ICON_MAP = {
  home: Home,
  inbox: Inbox,
  "file-text": FileText,
  "check-circle": CheckCircle,
  check: Check,
  "credit-card": CreditCard,
  shield: Shield,
  activity: Activity,
  search: Search,
  bell: Bell,
  settings: Settings,
  "chevron-right": ChevronRight,
  "chevron-left": ChevronLeft,
  "chevron-down": ChevronDown,
  "chevron-up": ChevronUp,
  filter: Filter,
  "arrow-left": ArrowLeft,
  "arrow-right": ArrowRight,
  "arrow-up": ArrowUp,
  "arrow-down": ArrowDown,
  plus: Plus,
  minus: Minus,
  maximize: Maximize,
  x: X,
  "alert-triangle": AlertTriangle,
  "alert-circle": AlertCircle,
  eye: Eye,
  edit: Edit,
  refresh: RefreshCw,
  "rotate-cw": RotateCw,
  "rotate-ccw": RotateCcw,
  "undo-2": Undo2,
  "redo-2": Redo2,
  download: Download,
  send: Send,
  zap: Zap,
  sparkles: Sparkles,
  user: User,
  users: Users,
  calendar: Calendar,
  clock: Clock,
  menu: Menu,
  database: Database,
  server: Server,
  cpu: Cpu,
  keyboard: Keyboard,
  play: Play,
  pause: Pause,
  image: Image,
  info: Info,
  "search-icon": Search,
  doc: FileText,
  pdf: FileText,
  flow: Activity,
  spark: Sparkles,
  "monitor-chart": MonitorChart,
} as const;

type IconName = keyof typeof ICON_MAP;

interface IconProps extends Omit<LucideProps, "ref"> {
  name: IconName;
}

/** lucide-react 아이콘 래퍼 — name 으로 아이콘 선택 */
const Icon = ({ name, size = 16, ...rest }: IconProps) => {
  const LucideIcon = ICON_MAP[name];
  if (!LucideIcon) return null;
  return <LucideIcon size={size} strokeWidth={1.8} {...rest} />;
};

export { Icon, ICON_MAP };
export type { IconName, IconProps };
